import { Link, Outlet, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import Footer from "./Footer";
export default function Header() {
   const params = useParams()
   const refresh = useRef(null)
   const changeLanguage = (lang) => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
         select.value = lang;
         select.dispatchEvent(new Event("change"));
      }
   };

   useEffect(() => {
      var MenuContener = document.querySelectorAll(".dropdown-menu");
      MenuContener.forEach((contener) => {
         if (getComputedStyle(contener).display.toLowerCase() === 'block') {
            // contener.style.display ='none !important'
            contener.classList.add("removemenu")
         }
      })

   }, [params]);
   const RemoveClass = () => {
      var MenuContener = document.querySelectorAll(".removemenu");
      MenuContener.forEach((contener) => { contener.classList.remove("removemenu") })
   }

   return (
      <>
         <button ref={refresh} aria-label="URL Refresh"></button>
         <div className="main-page-wrapper font-rubik">
            <div className="chatbot"></div>
            <div class="offcanvas offcanvas-start dlabnav-width" tabindex="-1" id="Outernav" aria-labelledby="offcanvasExampleLabel">
               <div class="offcanvas-header border-bottom">
                  <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                     <img src="/files/img/static/logo-dark.webp" loading="lazy" width="150" alt="Logo Taskflier" />
                  </h5>
                  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
               </div>
               <div class="offcanvas-body py-0 px-0">
                  <div class="dlabnav">
                     <div class="dlabnav-scroll mm-active">
                        <ul class="metismenu mm-show" id="menu">
                           <li class="mm-active" data-bs-dismiss="offcanvas">
                              <Link to="/">
                                 <i class="bi bi-grid"></i>Home
                              </Link>
                           </li>
                           <li>
                              <Link class="has-arrow " to="#Master" role="button" data-bs-toggle="collapse" aria-expanded="False" aria-controls="Master">
                                 <i class="bi bi-building"></i>
                                 <span class="nav-text">Solutions</span>
                              </Link>
                              <ul class="collapse" data-bs-parent="#navbarVerticalCollapse" id="Master">
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/enterprise">
                                       Enterprise</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/construction">
                                       Construction</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/software-development">
                                       Software Development</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/education">
                                       Education</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/marketing">
                                       Marketing</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/startup">
                                       Startup</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/testing">
                                       Testing</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/real-estate">
                                       Real Estate</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/consulting-services">
                                       Consulting Services</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/law">
                                       Law</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/solutions/chartered-accountant">
                                       CA Management</Link>
                                 </li>
                              </ul>
                           </li>
                           <li>
                              <Link class="has-arrow " to="#Franchise" role="button" data-bs-toggle="collapse" aria-expanded="False" aria-controls="Franchise">
                                 <i class="bi bi-shop"></i>
                                 <span class="nav-text">Features</span>
                              </Link>
                              <ul class="collapse" data-bs-parent="#navbarVerticalCollapse" id="Franchise">
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/theme-customizations">
                                       <span>Theme Customizations</span>
                                    </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/task-management-software">
                                       Task Management </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/employee-management-software">
                                       Employee Management </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/client-management-software">
                                       Client Management</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/charts-reporting">
                                       Charts &amp; Reporting</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/attendance-management-software">
                                       Attendance</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/todo-list">
                                       Todo List </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/time-tracking-software">
                                       Time Tracking</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/payment-expense">
                                       Payment & Expense </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/team-chat">
                                       Team Chat </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/appointment">
                                       Appointment</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/employee-documentation">
                                       Employee Documentation</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/lead-management-software">
                                       Leads Management</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/mobile-access">
                                       Mobile Access </Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/features/hr-management-software">
                                       HR Management </Link>
                                 </li>
                              </ul>
                           </li>
                           <li data-bs-dismiss="offcanvas">
                              <Link to="/customers">
                                 <i class="bi bi-people"></i>Customers
                              </Link>
                           </li>

                           <li>
                              <Link class="has-arrow " to="#pricing" role="button" data-bs-toggle="collapse" aria-expanded="False" aria-controls="Master">
                                 <i class="bi bi-credit-card"></i>
                                 <span class="nav-text">Pricing</span>
                              </Link>
                              <ul class="collapse" data-bs-parent="#navbarVerticalCollapse" id="pricing">
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/pricing">
                                       Project Management</Link>
                                 </li>
                                 <li data-bs-dismiss="offcanvas">
                                    <Link to="/pricing#HRMS">
                                       HRMS Pricing</Link>
                                 </li>

                              </ul>
                           </li>

                           {/* <li data-bs-dismiss="offcanvas">
                              <Link to="/pricing">
                                 <i class="bi bi-credit-card"></i>Pricing
                              </Link>
                           </li> */}
                           <li data-bs-dismiss="offcanvas">
                              <Link to="/contact-us">
                                 <i class="bi bi-envelope"></i>Contact
                              </Link>
                           </li>
                           <li data-bs-dismiss="offcanvas">
                              <Link to="/blog" >
                                 <i class="bi bi-newspaper"></i>Blog
                              </Link>
                           </li>
                           <li data-bs-dismiss="offcanvas">
                              <Link to="/upcomingevent">
                                 <i class="bi bi-calendar-plus"></i>Upcoming Event
                              </Link>
                           </li>
                           <li>
                              <Link class="has-arrow" to="#Language" role="button" data-bs-toggle="collapse" aria-expanded="False" aria-controls="Language">
                                 <i class="bi bi-translate"></i>
                                 <span class="nav-text">Language</span>
                              </Link>
                              <ul class="collapse Language-check" data-bs-parent="#navbarVerticalCollapse" id="Language">
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("en")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/us.png" loading="lazy" className="flag me-2" alt="English" />  English </label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("es")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/es.png" loading="lazy" className="flag me-2" alt="Español" />  Español </label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("pt")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/pt.png" loading="lazy" className="flag me-2" alt="Português" />  Português (Brasil)</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("de")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/de.png" loading="lazy" className="flag me-2" alt="Deutsch" />  Deutsch</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("fr")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/fr.png" loading="lazy" className="flag me-2" alt="Français" />  Français</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("nl")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/nl.png" loading="lazy" className="flag me-2" alt="Nederlands" />  Nederlands</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("ja")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/jp.png" loading="lazy" className="flag me-2" alt="JAPAN" />  日本語</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("ar")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/sa.png" loading="lazy" className="flag me-2" alt="German" />  العربية</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("id")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/id.png" loading="lazy" className="flag me-2" alt="Indonesia" />  Bahasa Indonesia</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("th")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/th.png" loading="lazy" className="flag me-2" alt="German" />  ภาษาไทย</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("vi")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/vi.png" loading="lazy" className="flag me-2" alt="German" />  Tiếng Việt</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("fr")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/fr.png" loading="lazy" className="flag me-2" alt="Canada" />  Français (Canada)</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("zh-TW")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/ch.png" loading="lazy" className="flag me-2" alt="Chaina" />  繁体中文</label></li>
                                 <li data-bs-dismiss="offcanvas" onClick={() => changeLanguage("it")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/it.png" loading="lazy" className="flag me-2" alt="Italiano" />  Italiano</label></li>
                              </ul>
                           </li>
                           <li>
                              <Link to="https://accounts.taskflier.com" class="has-arrow " role="button" >
                                 <i class="bi bi-person-bounding-box"></i>
                                 <span class="nav-text">Login</span>
                              </Link>
                           </li>
                           <li data-bs-dismiss="offcanvas" className="bg-primary ">
                              <a href="https://play.google.com/store/apps/details?id=com.mnb.taskflier_app" target="_blank" className="text-white">
                                 <i class="bi bi-google-play text-white"></i>Download App
                              </a>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
            <div className="theme-main-menu sticky-menu theme-menu-one">
               <div className="d-flex align-items-center justify-content-between">
                  <div className="logo-main">
                     <Link to="/">
                        <img src="/main/images/logo/mnb-project.webp" loading="lazy" alt="Logo Taskflier" />
                     </Link>
                  </div>
                  <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
                     <div className="nav-container">
                        <button className="navbar-toggler" data-bs-toggle="offcanvas" href="#Outernav" type="button" role="button" aria-label="toggle button" aria-expanded="false">
                           <span />
                        </button>

                        <div class="navbar-collapse collapse " id="navbarSupportedContent">
                           <div class="d-lg-flex align-items-center">

                              <ul class="navbar-nav container">

                                 <li class="nav-item dropdown position-static  megamenu" onMouseOver={RemoveClass}>
                                    <a class="nav-link dropdown-toggle" href="/" data-toggle="dropdown">
                                       Solutions
                                    </a>
                                    <div class="dropdown-menu p-0 solutionmenu-box " >
                                       <div className="dropdown-box px-4 pb-0">
                                          <div className="row">
                                             <div className="col-md-12">
                                                <div class="row ">
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/enterprise">
                                                         <div class="mega-item mb-20 mt-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-buildings-fill"></i> Enterprise
                                                            </div>
                                                            <div class="pack-details">Helps enterprise-wide planning, resource allocation and managing teams' coordination.</div>
                                                         </div>
                                                      </Link>
                                                   </div>

                                                 
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/construction">
                                                         <div class="mega-item mb-20 mt-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-building-add"></i> Construction
                                                            </div>
                                                            <div class="pack-details">Facilitates project scheduling, resource management and activity tracking.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/software-development">
                                                         <div class="mega-item mb-20 mt-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-code-slash"></i>Software Development
                                                            </div>
                                                            <div class="pack-details">Streamlines collaboration, resource allocation and development monitoring.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/education">
                                                         <div class="mega-item mb-20 mt-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-journal-bookmark-fill"></i> Education
                                                            </div>
                                                            <div class="pack-details">Manages activities related to students, teachers, courses, batches and fees end-to-end.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/marketing">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-journal-bookmark-fill"></i> Marketing
                                                            </div>
                                                            <div class="pack-details">Promotes effective campaign planning, monitoring, execution and control.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/startup">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-rocket-takeoff-fill"></i> Startup
                                                            </div>
                                                            <div class="pack-details">Supports faster project execution. Team organization and resource management.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/testing">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-braces-asterisk"></i> Testing
                                                            </div>
                                                            <div class="pack-details">Organizes testing tasks. Follow the progress and manage problem-solving.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/real-estate">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-building-fill"></i> Real Estate
                                                            </div>
                                                            <div class="pack-details">Helps asset management, sale and purchase, and crew collaboration</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3 ">
                                                      <Link to="/solutions/consulting-services">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-headset"></i> Consulting Services
                                                            </div>
                                                            <div class="pack-details">Improves customer management, resource allocation and team management </div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3">
                                                      <Link to="/solutions/law">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-award-fill"></i> Law
                                                            </div>
                                                            <div class="pack-details">Facilitates problem management, task tracking, and seamless document management.</div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3">
                                                      <Link to="/solutions/chartered-accountant">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-laptop-fill"></i> Chartered Accountant
                                                            </div>
                                                            <div class="pack-details">Facilitates client management, customer relationships and productivity </div>
                                                         </div>
                                                      </Link>
                                                   </div>
                                                   <div class="col-lg-3">
                                                      <Link to="/solutions/hospitality">
                                                         <div class="mega-item mb-20">
                                                            <div class="pack-name font-rubik">
                                                               <i class="bi bi-suitcase-fill"></i> Hospitality
                                                            </div>
                                                            <div class="pack-details">Exceptional service creating unforgettable guest experiences always</div>
                                                         </div>
                                                      </Link>
                                                   </div>

                                                </div>
                                             </div>
                                             <div className="col-md-2" hidden>
                                                <div className="secure">
                                                   <ul>
                                                      <li>
                                                         <i class="bi bi-check2"></i> Secured Data
                                                      </li>
                                                      <li>
                                                         <i class="bi bi-check2"></i> Fast & Scalable
                                                      </li>
                                                      <li>
                                                         <i class="bi bi-check2"></i> 24*7 Support
                                                      </li>
                                                      <li>
                                                         <i class="bi bi-check2"></i> Customizable
                                                      </li>
                                                   </ul>
                                                </div>
                                             </div>
                                          </div>
                                          <div className="bottom-item">
                                             <Link to="/contact-us" className="item-text">
                                                <span className="">
                                                   <i class="ri-message-2-line"></i> Contact us
                                                </span>
                                             </Link>
                                             <Link to="https://www.youtube.com/watch?v=5P-kl8qLjXU&list=PL_LnYUXYu7lqozY0i7bzHYx6_oKwDR5PF" className="item-text" target="_blank">
                                                <span className="">
                                                   <i class="ri-play-large-line"></i> Watch Demo
                                                </span>
                                             </Link>
                                             <Link to="https://play.google.com/store/apps/details?id=com.mnb.taskflier_app" className="item-text mr-0" target="_blank">
                                                <span className="">
                                                   <i class="bi bi-phone"></i> Download apps
                                                </span>
                                             </Link>
                                          </div>
                                       </div>
                                    </div>
                                 </li>
                                 <li class="nav-item dropdown position-static  megamenu" onMouseOver={RemoveClass}>
                                    <Link class="nav-link dropdown-toggle" data-toggle="dropdown">
                                       Features
                                    </Link>

                                   

                                    <div class="dropdown-menu p-0 " >
                                       <div className="dropdown-box px-4 pb-0">
                                          <div className="row">
                                             <div className="col-md-10">
                                               <div class="row">
    <div class="col-lg-4">
        <div class="menu-column pa-3 pt-4">
            <ul class="mega-dropdown-list featuresitem">

                {/* Theme Customizations */}
                <li>
                    <Link to="/features/theme-customizations" class="">
                        <div class="service-item active">
                            <div class="service-icon">
                                <i class="bi bi-palette-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Theme Customizations</span>
                                <small className="d-block helptext mt-1">
                                    Tailor TaskFlier’s borders, colors, and layout to reflect your brand’s style
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Task Management */}
                <li>
                    <Link to="/features/task-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-list-task"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Task Management</span>
                                <small className="d-block helptext mt-1">
                                    Organize, assign, track tasks, and streamline workflows to boost team productivity.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Employee Management */}
                <li>
                    <Link to="/features/employee-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-person-square"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Employee Management</span>
                                <small className="d-block helptext mt-1">
                                    Enhance profiles, task assignments, and workload for smooth, efficient operations.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Client Management */}
                <li>
                    <Link to="/features/client-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-person-check"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Client Management</span>
                                <small className="d-block helptext mt-1">
                                    Maintain detailed records of customers for stronger business relationships.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Charts & Reporting */}
                <li>
                    <Link to="/features/charts-reporting" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-bar-chart-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Charts & Reporting</span>
                                <small className="d-block helptext mt-1">
                                    Create visual reports to analyze progress, resource use and efficiency.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

            </ul>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="menu-column pa-3 pt-4">
            <ul class="mega-dropdown-list featuresitem">

                {/* Attendance */}
                <li>
                    <Link to="/features/attendance-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-calendar2-check-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Attendance</span>
                                <small className="d-block helptext mt-1">
                                    Effectively track and manage the presence, absence, and availability of employees.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Todo List */}
                <li>
                    <Link to="/features/todo-list" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-list-stars"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Todo List</span>
                                <small className="d-block helptext mt-1">
                                    Create, prioritize and manage tasks to keep your business organized all the time.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Time Tracking */}
                <li>
                    <Link to="/features/time-tracking-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-alarm-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Time Tracking</span>
                                <small className="d-block helptext mt-1">
                                    Track employee hours and project progress for the most recent billing.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Payment & Expense */}
                <li>
                    <Link to="/features/payment-expense" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-credit-card-2-back-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Payment & Expense</span>
                                <small className="d-block helptext mt-1">
                                    Track payments, expenses, and manage financial transactions in one place.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Team Chat */}
                <li>
                    <Link to="/features/team-chat" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-chat-dots-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Team Chat</span>
                                <small className="d-block helptext mt-1">
                                    Collaborate instantly with your team using true messaging functionality.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

            </ul>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="menu-column pa-3 pt-4">
            <ul class="mega-dropdown-list featuresitem">

                {/* Appointment */}
                <li>
                    <Link to="/features/appointment" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-calendar-date-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Appointment</span>
                                <small className="d-block helptext mt-1">
                                    Plan and manage customer appointments to ensure correct conditions are met.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Employee Documentation */}
                <li>
                    <Link to="/features/employee-documentation" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-file-earmark-text-fill"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Employee Documentation</span>
                                <small className="d-block helptext mt-1">
                                    Store and manage employee documents securely within the platform.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Leads Management */}
                <li>
                    <Link to="/features/lead-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-list-ul"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Leads Management</span>
                                <small className="d-block helptext mt-1">
                                    Manage and pursue potential business opportunities to increase sales growth.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* Mobile Access */}
                <li>
                    <Link to="/features/mobile-access" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-android2"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">Mobile Access</span>
                                <small className="d-block helptext mt-1">
                                    Stay connected, manage tasks, and review projects seamlessly.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

                {/* HR Management */}
                <li>
                    <Link to="/features/hr-management-software" class="">
                        <div class="service-item">
                            <div class="service-icon">
                                <i class="bi bi-person-bounding-box"></i>
                            </div>
                            <div class="service-content">
                                <span className="font-rubik">HR Management</span>
                                <small className="d-block helptext mt-1">
                                    Stay connected, manage tasks, and review projects seamlessly.
                                </small>
                            </div>
                        </div>
                    </Link>
                </li>

            </ul>
        </div>
    </div>
</div>

                                               
                                             </div>
                                             <div className="col-md-2">
                                                <div className="secure pt-0 mr-0">
                                                   <img src="/main/images/mega-menu.webp" loading="lazy" alt="mega-menu" />
                                                </div>
                                             </div>
                                          </div>

                                          <div className="bottom-item">
                                             <Link to="/contact-us" className="item-text">
                                                {" "}
                                                <span className="">
                                                   {" "}
                                                   <i class="ri-message-2-line"></i> Contact Sales
                                                </span>
                                             </Link>
                                             <Link to="https://www.youtube.com/watch?v=5P-kl8qLjXU&list=PL_LnYUXYu7lqozY0i7bzHYx6_oKwDR5PF" className="item-text" target="_blank">
                                                <span className="">
                                                   {" "}
                                                   <i class="ri-play-large-line"></i> Watch Demo
                                                </span>
                                             </Link>
                                             <Link to="https://play.google.com/store/apps/details?id=com.mnb.taskflier_app" className="item-text mr-0" target="_blank">
                                                <span className="">
                                                   {" "}
                                                   <i class="bi bi-phone"></i> Download apps
                                                </span>
                                             </Link>
                                          </div>
                                       </div>
                                    </div>

                                 </li>
                                 <li class="nav-item">
                                    <Link to="/customers" class="nav-link">
                                       Customers
                                    </Link>
                                 </li>
                                 <li class="nav-item dropdown" onMouseOver={RemoveClass}>
                                    <Link class="nav-link dropdown-toggle" to="#" data-toggle="dropdown">Pricing</Link>
                                    <ul class="dropdown-menu px-2">
                                       <li>
                                          <Link to="/pricing" data-discover="true"><div class="mega-item mb-2 mt-0"><div class="pack-name font-14"><i class="bi bi-ui-checks-grid"></i>&nbsp;Project Management</div><div class="pack-details">Empower teams to plan, collaborate, and deliver projects faster with complete visibility and control.</div></div></Link>


                                       </li>
                                       <li>
                                          <Link to="/pricing#HRMS" data-discover="true"><div class="mega-item mb-0 mt-0"><div class="pack-name font-14"><i class="bi bi-person-bounding-box"></i>&nbsp;HRMS Pricing</div><div class="pack-details">Streamline HR operations, attendance, payroll, and employee management.</div></div></Link>

                                       </li>

                                    </ul>
                                 </li>
                                 {/* <li class="nav-item">
                                    <Link class="nav-link" to="/pricing">
                                       Pricing
                                    </Link>
                                 </li> */}
                                 <li class="nav-item">
                                    <Link class="nav-link" to="/upcomingevent">
                                       Upcoming Event
                                    </Link>
                                 </li>
                              </ul>
                              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                              </div>
                              <ul class="right-button-group d-flex align-items-center justify-content-center">
                                 <li class="nav-item dropdown translate-box">
                                    <a class="nav-link dropdown-toggle" href="/" data-toggle="dropdown"><i class="bi bi-translate me-1"></i>Eng</a>
                                    <ul class="dropdown-menu">
                                       <li>
                                          <div className="row">
                                             <div className="col-md-6">
                                                <li onClick={() => changeLanguage("en")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/us.png" loading="lazy" className="flag me-2" alt="English" />  English </label></li>
                                                <li onClick={() => changeLanguage("es")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/es.png" loading="lazy" className="flag me-2" alt="Español" />  Español </label></li>
                                                <li onClick={() => changeLanguage("pt")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/pt.png" loading="lazy" className="flag me-2" alt="Português" />  Português (Brasil)</label></li>
                                                <li onClick={() => changeLanguage("de")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/de.png" loading="lazy" className="flag me-2" alt="Deutsch" />  Deutsch</label></li>
                                                <li onClick={() => changeLanguage("fr")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/fr.png" loading="lazy" className="flag me-2" alt="Français" />  Français</label></li>
                                                <li onClick={() => changeLanguage("nl")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/nl.png" loading="lazy" className="flag me-2" alt="Nederlands" />  Nederlands</label></li>
                                                <li onClick={() => changeLanguage("ja")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/jp.png" loading="lazy" className="flag me-2" alt="JAPAN" />  日本語</label></li>
                                             </div>
                                             <div className="col-md-6">
                                                <li onClick={() => changeLanguage("ar")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/sa.png" loading="lazy" className="flag me-2" alt="German" />  العربية</label></li>
                                                <li onClick={() => changeLanguage("id")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/id.png" loading="lazy" className="flag me-2" alt="Indonesia" />  Bahasa Indonesia</label></li>
                                                <li onClick={() => changeLanguage("th")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/th.png" loading="lazy" className="flag me-2" alt="German" />  ภาษาไทย</label></li>
                                                <li onClick={() => changeLanguage("vi")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/vi.png" loading="lazy" className="flag me-2" alt="German" />  Tiếng Việt</label></li>
                                                <li onClick={() => changeLanguage("fr")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/fr.png" loading="lazy" className="flag me-2" alt="Canada" />  Français (Canada)</label></li>
                                                <li onClick={() => changeLanguage("zh-TW")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/ch.png" loading="lazy" className="flag me-2" alt="Chaina" />  繁体中文</label></li>
                                                <li onClick={() => changeLanguage("it")}><label class="dropdown-item d-flex notranslate"><img src="/main/flag/it.png" loading="lazy" className="flag me-2" alt="Italiano" />  Italiano</label></li>
                                             </div>
                                          </div>
                                       </li>
                                    </ul>
                                 </li>
                                 <li class="nav-item dropdown customlogin">
                                    <Link to="https://accounts.taskflier.com/" class="nav-link customlogin" role="button">
                                       Login
                                    </Link>
                                 </li>
                                 <li>
                                    <Link
                                       to={`/demo-request`}
                                       type="button"
                                       class="btn signUp-action"
                                    >
                                       Request Demo
                                    </Link>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </nav>
               </div>
            </div>
            <Outlet />
            <Footer />
            <button className="scroll-top" style={{ display: "none" }}>
               <i className="fa fa-angle-up" aria-hidden="true" />
            </button>
         </div>
      </>
   );
}
